import { push } from 'connected-react-router'
import { CALL_API } from '../../util/RBRestMiddleware'
import { AccountLoginErrorCodes } from '../../util/ErrorCodes'
import Config from '../../Config'
import Auth from '../../auth/Auth'
import { fetchMemberSummary } from '../../redux/actions/memberSummaryActions'

// Log into the system
export const LOGIN_LOADING = 'LOGIN_LOADING'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'

export const MULTI_POLICY_LOGIN = 'MULTI_POLICY_LOGIN'
export const MULTI_POLICY_SUCCESS = 'MULTI_POLICY_SUCCESS'

export const VALIDATION_LOADING = 'VALIDATION_LOADING'
export const VALIDATION_FAILED = 'VALIDATION_FAILED'
export const VALIDATION_SUCCESS = 'VALIDATION_SUCCESS'

export const ACTIVATE_REQUIRED = 'ACTIVATE_REQUIRED'
export const activateRequired = () => {
  return {
    type: ACTIVATE_REQUIRED
  }
}

export const saveUserData = (userEmail, userPassword, isSessionValidation) => {
  return {
    type: MULTI_POLICY_LOGIN,
    userEmail: userEmail,
    userPassword: userPassword,
    isSessionValidation: isSessionValidation
  }
}

export const clearUserData = () => {
  return {
    type: MULTI_POLICY_SUCCESS
  }
}

export const login = (username, password) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        method: 'post',
        path: '/account/login',
        prefix: 'LOGIN',
        query: { 'email': username, 'password': password },
        onSuccess: () => {
          if (Auth.ngrxIsMultiPolicies) {
            dispatch(push('/MultiPolicy'))
          } else {
            dispatch(fetchMemberSummary())
            dispatch(push(`/${Config.landingPage}`))
          }
        },
        onError: (err) => {
          if (err.code === AccountLoginErrorCodes.ACTIVATION_REQUIRED) {
            window.localStorage.setItem('stepIndex', 0)
            dispatch(push('/activate'))
          }
        }
      }
    })
  }
}
export const loginWithPolicy = (submitObject) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        method: 'post',
        path: '/account/login/policy',
        prefix: 'LOGIN',
        query: submitObject,
        onSuccess: () => {
          clearUserData()
          dispatch(fetchMemberSummary())
          dispatch(push(`/${Config.landingPage}`))
        },
        onError: (err) => {
          return err
        }
      }
    })
  }
}

// for single sign on functionality
export const validateSession = (sessionId) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        method: 'get',
        path: `/account/validateSession/${sessionId}`,
        prefix: 'VALIDATION',
        onSuccess: () => {
          if (Auth.ngrxIsMultiPolicies) {
            dispatch(push('/MultiPolicy'))
          } else {
            clearUserData()
            dispatch(fetchMemberSummary())
            dispatch(push(`/${Config.landingPage}`))
          }
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/loginActions.js